import React from 'react';
import classNames from 'classnames';
import WidgetCoupon from 'modules/shared/widgets/shared/widget-coupon';
import WidgetPhotosGridTeaserManualProps
    from 'modules/shared/widgets/components/widget-photos-grid-teaser-manual/widget-photos-grid-teaser-manual.props';
import WidgetPhotosGridTeaserManualDesktopSlider
    from './components/widget-photos-grid-teaser-manual-desktop-slider/widget-photos-grid-teaser-manual-desktop-slider';
import './widget-photos-grid-teaser-manual.desktop.scss';

const WidgetPhotosGridTeaserManualDesktop: React.FC<WidgetPhotosGridTeaserManualProps> = ({ config, data }) => {
    const shouldCouponBeVisible = (config.coupon || []).some(couponItem => couponItem.text);

    return (
        <div className="w-photos-grid-teaser-manual-d">
            { shouldCouponBeVisible && (
                <div className="w-photos-grid-teaser-manual-d__coupon">
                    <WidgetCoupon coupon={config.coupon} />
                </div>
            )}
            <div
                className={classNames({
                    'w-photos-grid-teaser-manual-d__slider': true,
                    'w-photos-grid-teaser-manual-d__slider--right': shouldCouponBeVisible
                })}
            >
                <WidgetPhotosGridTeaserManualDesktopSlider data={data} config={config} isSliderSmall={shouldCouponBeVisible} />
            </div>
        </div>
    );
};

export default WidgetPhotosGridTeaserManualDesktop;
